// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"37e458f4","315":"7cc40dc2","525":"01b2f73e","557":"45fa6e29","690":"1eda8ee9"}[chunkId] + ".chunk.js";
};